module.exports = __webpack_public_path__ + "static/img/yuanimg.e25a98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/yunwei/yuanimg.png
// module id = 8l7x
// module chunks = 6